import 'babel-polyfill';
import 'whatwg-fetch';

// assets
import '~/styles/index.scss';
import '~/images/favicon-32x32.png';
import '~/images/favicon-16x16.png';
import '~/images/bell.png';
import '~/videos/intro.mp4';
import '~/videos/intro.ogg';

import YouTubeAPI from './core/YouTubeAPI.js';
import Page from './components/Page.js';

const page = Page({
    el: document.body
});

YouTubeAPI.init(() => {
    page.start();
});



// WEBPACK FOOTER //
// ./assets/js/index.js